type OrganizationScopedReset = () => void;

const organizationScopedResets = new Set<OrganizationScopedReset>();

export function RegisterOrganizationScopedState(reset: OrganizationScopedReset): void {
  organizationScopedResets.add(reset);
}

export function ClearOrganizationScopedState(): void {
  for (const reset of organizationScopedResets) {
    reset();
  }
}
